import * as yup from 'yup';
import {
  validationEmailField,
  validationNewPassword,
} from './defaultValidations';

export default yup.object().shape({
  Email: validationEmailField('Email', 8, 100, 'Your Email is invalid.'),
  Password: validationNewPassword('Password', 8, 127),
});
